import type { ReactNode } from 'react';

export const symbol_crop: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M695-70v-135H265q-24 0-42-18t-18-42v-430H70q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32Q57.25-755 70-755h135v-135q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v625h625q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H755v135q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Q695-57.25 695-70Zm0-255v-370H325v-60h370q24 0 42 18t18 42v370h-60Z"
		/>
	</svg>
);
